import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconLoginOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m5.971 6.93 1.06-1.06L13.158 12 7.03 18.13l-1.059-1.061 4.319-4.32H0v-1.5h10.29zM22.5 0A1.5 1.5 0 0 1 24 1.5v21a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 9 22.5v-2.25h1.5v2.25h12v-21h-12v2.25H9V1.5A1.5 1.5 0 0 1 10.5 0z" /></svg>
);
